export enum MultiTreeSelectGroupTypeEnum {
  ORGANIZATIONS = 'ORGANIZATIONS',
  EXTRA = 'EXTRA',
}
